export default "__VITE_ASSET__Dls3$mWf__"